import React from 'react';
import { projectsData } from '../assets/projects-json/projectsData'; // Assuming this contains all your project data
import Slider from 'react-slick';
import PagesHeading from '../components/PagesHeading';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo_without_text.png';

const Projects = () => {
  const navigate = useNavigate();

  // Slider settings
  const settings = {
    dots: false,
    fade: true,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true, // Enable autoplay
    autoplaySpeed: 1000,
  };

  return (
    <div>
      <PagesHeading heading="Projects" />
      
      <div className="flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-center mt-5 lg:mt-10">
        <div className="grid grid-cols-1 relative md:grid-cols-4 xl:grid-cols-3 gap-3">
          {/* Dynamically render each project */}
          {projectsData.map((project) => (
            <div key={project.id} className="rounded-2xl cursor-pointer"   onClick={() => navigate(`/projects/projectdetails/${project.id}`)} >
              <Slider {...settings}>
                {project.thumbnails.map((thumbnail, index) => (
                  <div key={index} className="px-2 relative rounded-2xl">
                    <img className="w-20 absolute z-10" src={logo} alt="logo" />
                    <img className="rounded-2xl w-full" src={thumbnail} alt={project.title} />
                  </div>
                ))}
              </Slider>
              <div className="flex justify-between items-center gap-x-3">
                <h1 className="text-justify text-lg mx-2 font-semibold">
                  {project.title}
                </h1>
                <button 
                  onClick={() => navigate(`/projects/projectdetails/${project.id}`)} 
                  className="hover:bg-primaryColor group border border-primaryColor p-2 rounded-full">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6 stroke-primaryColor group-hover:stroke-white transition-colors duration-300"
                  >
                    <path
                      d="M6 18L18 6M18 6H9M18 6V15"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
